import React, { useState } from "react";
import { Button, Input, Checkbox, Alert } from "@heroui/react";

const MarketForm = ({
  formData,
  setFormData,
  onSubmit,
  onCancel,
  setShowForm,
  getAdminDashboardMarkets,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = async (e) => {  
    try {
      e.preventDefault();
      setShowAlert(false);
      setAlertMessage("");

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      formData.created_by = localStorage.getItem("uid");

      const baseUrl = process.env.REACT_APP_API_HOST;
      const url = formData.market_id
        ? `${baseUrl}/updatemarket`
        : `${baseUrl}/addmarket`;

      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formData),
      };

      const response = await fetch(url, requestOptions);

      const result = await response.json();
      if (result.success === false) {
        throw new Error(result.message || "Failed to register/update market.");
      }

      let successMessage = formData.market_id
        ? "Market updated successfully!"
        : "Market added successfully!";

      getAdminDashboardMarkets();
      setAlertMessage(successMessage);
      setShowAlert(true);
        // setFormData({
        //   email: "",
        //   name: "",
        //   phone: "",
        //   password: "",
        //   role_id: "user",
        //   status: "",
        // });
      setTimeout(() => {
        setAlertMessage("");
        setShowAlert(false);
        setShowForm(false);
      }, 2000);
    } catch (err) {
      console.error("Error adding user:", err.message);
      setErrorMessage(err.message || "Something went wrong");
      setShowErrorAlert(true);
      setTimeout(() => {
        setAlertMessage("");
        setShowAlert(false);
        setErrorMessage("");
        setShowErrorAlert(false);
      }, 2000);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      {showAlert && (
        <Alert
          color="success"
          className="mb-4"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      )}
      {showErrorAlert && (
        <Alert
          color="danger"
          className="mb-4"
          onClose={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {formData.id ? "Edit Market" : "Add New Market"}
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Market Name
            </label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              placeholder="Enter Market name"
              required
              onChange={handleInputChange}
              // onChange={(e) =>
              //   setFormData({ ...formData, name: e.target.value })
              // }
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Market Active
            </label>
            <Checkbox
              size="md"
              color="success"
              // isSelected={formData.status === "active"}
              // onValueChange={(val) =>
              //   setFormData({
              //     ...formData,
              //     status: val ? "active" : "inactive",
              //   })
              // }
              isSelected={formData.status === 1}
              onChange={(event) => {
                setFormData((prev) => ({
                  ...prev,
                  status: formData.status === 1 ? 0 : 1,
                }));
              }}
            >
              Is active
            </Checkbox>
          </div>
        </div>
        <div className="flex justify-end space-x-3">
          <Button color="danger" variant="light" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" className="bg-admin_black text-white">
            {formData.id ? "Update Market" : "Save Market"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MarketForm;
